export class GeneralForm {
  constructor(data = {}) {
    this.name = data.name || null
    this.description = data.description || null
    this.address = data.address || null
    this.zip = data.zip || null
    this.city = data.city || null
    this.state = data.state || null
    this.countryId = data.countryId || null
    this.latitude = data.latitude || null
    this.longitude = data.longitude || null
    this.phone = data.phone || null
    this.starRate = data.starRate || null
  }
}

export class PreferencesForm {
  constructor(data) {
    const { preferences } = data

    this.tax = preferences.tax
    this.inventoryThreshold = preferences.inventoryThreshold
    this.timeZoneId = preferences.timeZoneId
    // this.baseCurrencyId = preferences.baseCurrencyId
    this.displayCurrencyId = preferences.displayCurrencyId
    this.tax = preferences.tax
    this.service = preferences.service
    this.showFees = preferences.showFees
    this.showStar = preferences.showStar
    this.useDecimal = preferences.useDecimal
    this.gaId = preferences.gaId
    this.pixelId = preferences.pixelId
  }
}

export class PolicyForm {
  constructor(data) {
    const { policy } = data

    this.termsAndConditions = policy.termsAndConditions
    this.privacyPolicy = policy.privacyPolicy
    this.checkInTime = policy.checkInTime
    this.checkOutTime = policy.checkOutTime
    this.maximumChildrenAge = policy.maximumChildrenAge
    this.maximumInfantAge = policy.maximumInfantAge
    this.childDisclaimer = policy.childDisclaimer
    this.droneDisclaimer = policy.droneDisclaimer
    this.outsideFoodDisclaimer = policy.outsideFoodDisclaimer
  }
}

export class MemberForm {
  constructor(data) {
    const { member } = data

    this.percentDiscount = member.percentDiscount
    this.pointValue = member.pointValue
    this.benefits = member.benefits
  }
}

export class SocmedForm {
  constructor(data) {
    const { instagram, facebook, twitter, youtube } = data.socialMedia

    this.instagram = instagram
    this.facebook = facebook
    this.twitter = twitter
    this.youtube = youtube
  }
}
